function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgLegal = function SvgLegal(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "m9.218 17.597-6.795-6.794a.376.376 0 0 1 0-.532l.872-.871a.376.376 0 0 1 .532 0l6.794 6.794a.376.376 0 0 1 0 .532l-.872.872a.376.376 0 0 1-.531 0ZM16.079 10.706 9.303 3.93a.386.386 0 0 1 0-.545l.858-.858c.15-.15.395-.15.546 0l6.775 6.775c.15.15.15.395 0 .546l-.858.858a.386.386 0 0 1-.545 0ZM21.675 20.513l-7.858-7.859-1.123 1.123 7.859 7.858zM3.994 9.567l5.473-5.473M15.922 10.55l-5.473 5.472"
  }));
};
export default SvgLegal;